/* eslint-disable max-len */
import {
  SPEC_TITLE,
  CATEGORY_NAME,
  SEARCH_LABEL_NAME,
  METADATA_ATTRIBUTE_NAMES,
  METADATA_SUPERSKU_NAMES,
  BACKUP_TYPE_NAME,
  FUEL_TYPE_NAMES,
  PRODUCT_REG_EXP,
  METADATA_REG_EXP,
  SEARCH_REG_EXP
} from './constants';

const specificationsSearch = (specifications, specName) => {
  return specifications?.find(({ specName: name }) => name === specName)?.specValue?.toLowerCase();
};

export const getProductSpecificationData = (product) => {
  const specifications = product?.specificationGroup?.find(({ specTitle }) => specTitle === SPEC_TITLE)?.specifications;
  const category = ((specificationsSearch(specifications, CATEGORY_NAME) ?? specificationsSearch(specifications, BACKUP_TYPE_NAME) ?? '')?.match(PRODUCT_REG_EXP) ?? [])[0];
  const type = FUEL_TYPE_NAMES.reduce((types, typeName) => {
    const typeValue = specificationsSearch(specifications, typeName);
    if (typeValue) {
      types.push(typeValue);
    }
    return types;
  }, [])[0];

  return {
    applianceType: type,
    applianceCategory: category
  };
};

const regExpReducer = ({ typeCategoryPairs = [], regExp }) => {
  return typeCategoryPairs?.reduce((acc, curr) => {
    const [type = '', category = ''] = curr?.match(regExp) ?? [];
    if (type && !acc.types.includes(type)) {
      acc.types.push(type);
    }

    if (category && !acc.categories.includes(category)) {
      acc.categories.push(category);
    }

    return acc;
  }, { types: [], categories: [] });
};

const attributeSearch = (attributes, attributeMatch) => {
  return attributes?.reduce((acc, { attributeValues, attributeName }) => {
    if (attributeMatch.includes(attributeName)) {
      return attributeValues.map(({ value }) => value?.toLowerCase());
    }
    return acc;
  }, null);
};

export const getMetadataAttributeData = (metadata) => {
  const { attributes, superDuperSku } = metadata || {};
  const { types: metadataTypes, categories: metadataCategories } = regExpReducer({
    typeCategoryPairs: (attributeSearch(attributes, METADATA_ATTRIBUTE_NAMES)
      ?? attributeSearch(superDuperSku?.attributes, METADATA_SUPERSKU_NAMES)),
    regExp: METADATA_REG_EXP
  });
  return {
    metadataTypes,
    metadataCategories
  };
};

const filterSearch = (filters) => {
  return filters?.find(({ label }) => label === SEARCH_LABEL_NAME)?.refinements?.map(({ label }) => label?.toLowerCase());
};

export const getSearchModelFilterData = (search) => {
  const { dimensions, primaryFilters } = search;

  const { types: filterTypes, categories: filterCategories } = regExpReducer({
    typeCategoryPairs: (filterSearch(dimensions) ?? filterSearch(primaryFilters)),
    regExp: SEARCH_REG_EXP
  });
  return {
    filterTypes,
    filterCategories
  };
};

export const track = ({ eventType }) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.top.LIFE_CYCLE_EVENT_BUS.trigger(`appliance-fuel-type-drawer.${eventType}`);
  }
};
